import styled from 'styled-components';

export const MapComponent = styled.section`
  img {
    max-width: 100%;
    height: auto;
  }
`;
